/**
 * Created by Tiger on 13/04/2022.
 */

import React, {useCallback} from 'react';
import {useState} from 'react';
import {http} from '../../common/request';
import {Button, message} from 'antd';
import i18n from 'i18next';

export const Footer = (props) => {
    return [
        <Button loading={ props.testLoading } onClick={ props.onTest }>{ i18n.t('test') }</Button>,
        <Button onClick={ props.onCancel }>{ i18n.t('cancel') }</Button>,
        <Button type={ 'primary' } onClick={ props.onOk }>{ i18n.t('consent') }</Button>,
    ];
};

export const useMqttTest = () => {
    return useConfigTest('mqtt', 'mqttConfig');
};

export const useAliConfigTest = () => {
    return useConfigTest('ali', 'aliConfig');
};


const useConfigTest = (type, configKey) => {
    const [loading, setLoading] = useState(false);
    const test = useCallback(params => {
        setLoading(true);
        http('post', '/v1/webapi/push/setting/check', {
            type,
            [configKey]: {
                ...params,
            },
        })
            .then(res => {
                if (res?.data?.msg) {
                    message.success(res.data.msg);
                } else {
                    message.warn(JSON.stringify(res.data));
                }
            }).catch(error => {
            if (error?.response?.data?.msg) {
                message.warn(error.response.data.msg);
            }else {
                message.warn(JSON.stringify(error.response.data))
            }
        })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return [loading, test];
};
